import { connect } from 'react-redux';
import DefaultSection from '../../views/section/default';
import FlapUtil from 'Utils/content/flap-util';
import SectionUtil from 'Utils/content/section-util';

const mapStateToProps = ({ sections }, { section }) => {
  const currentSection = FlapUtil.sectionOrDefaults(
    FlapUtil.getSectionByRemoteId(section.remoteid, sections.entries),
  );
  const isLoading = SectionUtil.isSectionLoading(
    currentSection.requestedRemoteId,
    sections.loading,
  );

  return {
    items: currentSection.items,
    isLoading,
    neverLoadMore: currentSection.neverLoadMore,
    followers: currentSection.followerProjections,
    followersLoading: currentSection.followersLoading,
    topicDescriptions: sections.topicDescriptions,
  };
};

const mapDispatchToProps = () => ({});

const DefaultSectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultSection);

export default DefaultSectionContainer;
